import React from 'react';

import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';
import withMenuEmptyState from 'features/menu/components/with-menu-empty-state';
import MinimalRecentItemsCardList from 'features/menu/pages/recent-items-page/minimal-recent-items';
import RecentOrderCardList from 'features/menu/pages/recent-items-page/recent-order-card-list';
import { View } from 'react-native';

import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';

const MenuRecentItemsComponent = () => {
  const enableMinimalCartUi = useMinimalCartUi();
  useExposeMinimalCartExperiment();

  return (
    <View style={{ flex: 1 }} testID="menu-recents-page">
      {enableMinimalCartUi ? <MinimalRecentItemsCardList /> : <RecentOrderCardList />}
    </View>
  );
};

export const MenuRecentItemsPage = withMenuEmptyState(MenuRecentItemsComponent);
